export default __webpack_public_path__ + "static/media/zero.91894f3a.wav";